import Hero from "@/components/Hero";
import FutureSignals from "@/components/FutureSignals";
import AwardRecognition from "@/components/AwardRecognition";
import RaulvinsTake from "@/components/RaulvinsTake";
import Newsletter from "@/components/Newsletter";
import ClosingSection from "@/components/ClosingSection";

const Home = () => {
  return (
    <main>
      <Hero />
      <FutureSignals />
      <AwardRecognition />
      <RaulvinsTake />
      <Newsletter />
      <ClosingSection />
    </main>
  );
};

export default Home;
